/**
 * @desc Imagry layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "openStreetMapStandard",
    layerTitle: "Open Street Map",
    visibility: false,
    attribution:
      "Base map and data from OpenStreetMap and OpenStreetMap Foundation.  © OpenStreetMap contributors."
  }
};
